<template>
    <a is="router-link" :to="page.url($store.state.language)"
       class="nav-date-item"
            v-bind:class="{'is-active':page.active}"
            v-on:click="$emit('select-item',page)">
        <span class="square">
            <span class="text">{{page.date}}</span>
        </span>
    </a>
</template>

<script>
    export default {
        name: "NavDateItem",
        props:['page'],
        data(){
          return {}
        },
        methods:{}
    }
</script>

<style scoped lang="less">
    .nav-date-item{
        cursor: pointer;
        outline: none;
        position: relative;
        background: transparent;
        border: none;
        color: #fff;
        width: 60px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;

        font-weight: normal;
        .text{
            opacity: 0.3;
            font-family: var(--typo-numbers);
            font-weight: normal;
        }
        &.router-link-active{
            .text{
                opacity: 1;
            }
        }

        .square{
            transform: rotate(-45deg);
            top: 0;
            left: 0;
            width: 0.7vw;
            height: 0.7vw;
            background-color: #fff;
            >.text{
                display: block;
                position: absolute;
                top: -1.7vw;
            }
        }

    }
</style>